import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/myexam")({
  component: lazyRouteComponent(
    () => import("@/features/exams/components/exams-page"),
    "ExamsPage",
  ),
});
